import { axios } from "../../../packs/axios";

export const currentMerchantAPI = {
  GETProgramSettings() {
    const fields = ['program_type', 'points_per_visit', 'points_per_dollar', 'loyalty', 'points_expiration_type', 'points_expiration_interval'].join(',');

    return axios.get('/api/v3/current_merchant/info', {
      params: {
        fields
      }
    }).then(resp => resp.data);
  },
  PUTProgramSettings(id, data) {
    return axios.put(`/api/v3/current_merchant/${id}`, data);
  }
}
